"use strict";

exports.__esModule = true;
exports.convertSearchObjectToSearchResult = void 0;

const convertSearchObjectToSearchResult = ({
  id,
  url,
  title,
  description
}) => ({
  id,
  url,
  title,
  description
});

exports.convertSearchObjectToSearchResult = convertSearchObjectToSearchResult;